window.trackMatomoEvent = function(eventName, eventData = null) {
    if (!window._paq) {
        return;
    }

    if(eventData !== null){
        window._paq.push(["trackEvent", eventName, eventData]);
    }else{
        window._paq.push(["trackEvent", eventName]);
    }

    // Log to console if dev instance
    if (document.documentElement.classList.contains("is-dev")) {
        console.log(`MATOMO EVENT TRACKING: ${eventName}: ${eventData}`);
    }
}
